/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// Users module

define('modules/User/Users',[
    'jquery',
    'global/all',
    './Users.Forms'
], function ($, Roc, UsersForms) {
    'use strict';

    var loginOptions;
    var loginData;
    var registrationOptions;

    var forgotPasswordOptions;
    var changePasswordData;
    var editAccountOptions = {};
    var editAccountData;
    var editUserData;

    // Forms definitions
    var forms = UsersForms;

    //  Enter handlers
    function handleLoginEnterEvt() {
        Roc.Core.handleEnter('#login_email, #login_password', login);
    }
    function handleRegistrationEnterEvt() {
        Roc.Core.handleEnter('#register_first_name, #register_last_name, #register_email, #register_email2, #register_password, #register_password2', register);
    }
    function handleForgotPasswordEnterEvt() {
        Roc.Core.handleEnter('#forgot_email', forgotPassword);
    }
    function handleChangePasswordEnterEvt() {
        Roc.Core.handleEnter('#forgot_password, #forgot_password2', changePassword);
    }
    function handleEditAccountEnterEvt() {
        Roc.Core.handleEnter('#current-password, #new-password, #new-password-confirm', editAccount);
    }

    // Specific events

    var btns = {
        login: '#loginBtn',
        register: '#registerBtn',
        forgotPass: '#forgotPasswordBtn',
        changePass: '#changePasswordBtn',
        editAccount: '#editAccountSaveBtn',        
        editAccountCancel: '#editAccountCancelBtn',
        editProfile: '#editProfileSaveBtn',
        editProfileCancel: '#editProfileCancelBtn'
    };

    function loginEvt() {
        $(document).on('click', btns.login, function () {
            login();
        });
    }

    function registerEvt() {
        $(document).on('click', btns.register, function () {
            register();
        });
    }

    var requestBusinessAccountCheckbox = '#requestBusinessAccount';
    var orgaizationNameWrapper = '#orgaizationNameWrapper';

    function checkOrganizationNameDispay() {
        var orgInputWrappr = $(orgaizationNameWrapper);
        if ($(requestBusinessAccountCheckbox).is(':checked')) {
            orgInputWrappr.show();
        } else {
            orgInputWrappr.hide();
        }
    }

    function requestBusinessAccountEvt() {
        checkOrganizationNameDispay();
        $(document).on('change', requestBusinessAccountCheckbox, function () {
            checkOrganizationNameDispay();
        });
    }

    function forgotEvt() {
        $(document).on('click', btns.forgotPass, function () {
            forgotPassword();
        });
    }

    function changePasswordEvt() {
        $(document).on('click', btns.changePass, function () {
            changePassword();
        });
    }

    function updateForgotPasswordUrlEvt() {
        $(document).on('blur', '#login_email', function () {
            var $btnForgotPassowrd = $('#btnForgotPassword');
            var forgotPassowrdUrl = $btnForgotPassowrd.attr('href');
            if (forgotPassowrdUrl) {
                if (forgotPassowrdUrl.indexOf('?') > -1) {
                    forgotPassowrdUrl = forgotPassowrdUrl.substr(0, forgotPassowrdUrl.indexOf('?'));
                }

                forgotPassowrdUrl += '?Email=' + encodeURIComponent($(loginData.email.Field).val());
                $btnForgotPassowrd.attr('href', forgotPassowrdUrl);
            }
        });
    }

    function editAccountSaveEvt() {
        $(document).on('click', btns.editAccount, function () {
            editAccount();
        });
    }

    function editProfileSaveEvt() {
        $(document).on('click', btns.editProfile, function () {
            editUserProfile();
        });
    }

    function editAccountCancelEvt() {
        $(document).on('click', btns.editAccountCancel, function () {
            Roc.Core.lockButton(btns.editAccountCancel);
            window.location.href = document.URL;
        });
    }

    function editProfileCancelEvt() {
        $(document).on('click', btns.editProfileCancel, function () {
            Roc.Core.lockButton(btns.editProfileCancel);
            window.location.href = document.URL;
        });
    }

    // START: Events binding

    function bindLoginEvents() {
        handleLoginEnterEvt();
        updateForgotPasswordUrlEvt();
        loginEvt();
    }

    function bindRegistrationEvents() {
        handleRegistrationEnterEvt();
        registerEvt();
        requestBusinessAccountEvt();
        Roc.EventManager.bind(Roc.Events.users.REGISTER, function (xhr) {
            var response = xhr.responseJSON || {};
            if (response.success && response.redir) {
                Roc.Core.lockButton(btns.register);
                window.location.replace(response.redir);
            }
        });
    }

    function bindForgotPasswordEvents() {
        handleForgotPasswordEnterEvt();
        handleChangePasswordEnterEvt();
        forgotEvt();
        changePasswordEvt();
    }

    function bindEditAccountEvents() {
        handleEditAccountEnterEvt();
        editAccountSaveEvt();
        editAccountCancelEvt();
    }

    function bindUserProfileEvents() {
        editProfileSaveEvt();
        editProfileCancelEvt();
    }

    // START: Public Methods
    function initLogin(options) {
        loginOptions = options || {};
        loginData = {
            'email': Roc.Validation.getField(forms.Login, 'Email')
        };
        bindLoginEvents();
    };

    function initRegistration(options) {
        registrationOptions = options || {};
        bindRegistrationEvents();
    };

    function initForgotPassword(options) {
        forgotPasswordOptions = options || {};
        changePasswordData = {
            '$pass': $(Roc.Validation.getField(forms.ChangePassword, 'Password').Field),
            '$pass2': $(Roc.Validation.getField(forms.ChangePassword, 'Confirm Password').Field)
        };
        bindForgotPasswordEvents();
    }

    function initEditAccount(options) {
        if (options) {
            this.editAccountOptions = options;
        }
        editAccountData = {
            '$newPass1': $(Roc.Validation.getField(forms.EditAccount, 'New Password').Field),
            '$newPass2': $(Roc.Validation.getField(forms.EditAccount, 'Retype New Password').Field)
        };
        bindEditAccountEvents();
    }

    function initEditProfile(options) {
        if (options) {
            this.editAccountOptions = options;
        }

        editUserData = {
            '$firstName': $(Roc.Validation.getField(forms.EditProfile, 'First Name').Field),
            '$lastName': $(Roc.Validation.getField(forms.EditProfile, 'Last Name').Field)
        };
        bindUserProfileEvents();
    }

    function login() {
        var $formWrapper = $(forms.Login.Fields[0].Field).closest('.formee');
        var $errorContainer = Roc.UI.getErrorSummaryWrapper($formWrapper);
        var isValid = Roc.Validation.validateForm(forms.Login);

        if (isValid) {
            Roc.Core.lockButton(btns.login);
            var requestData = Roc.Validation.getFieldValues(forms.Login);

            requestData.isCheckout = loginOptions.isCheckout || false;

            $.ajax({
                url: '/ajax/Login',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(requestData),
                beforeSend: loginOptions.beforeSend || null,
                complete: function (xhr) {
                    var response = xhr.responseJSON || {};

                    if (response.errorMessage) {
                        Roc.UI.template('formErrorSummary-Tmp', { message: response.errorMessage }).then(function (renderedTemplate) {
                            $errorContainer.html(renderedTemplate);
                        });
                    }

                    Roc.Core.releaseLockedButton(btns.login);
                    Roc.EventManager.notify(Roc.Events.users.LOGIN, xhr);
                }
            });
        }
    }

    function logout(logoutActionUrl) {
        $.ajax({
            url: logoutActionUrl || '/ajax/Logout',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            complete: function (xhr) {
                Roc.EventManager.notify(Roc.Events.users.LOGOUT, xhr);
            }
        });
        return false;
    }

    function register() {
        var $formWrapper = $(forms.Registration.Fields[0].Field).closest('.formee');
        var $errorContainer = Roc.UI.getErrorSummaryWrapper($formWrapper);
        $errorContainer.html('');

        var isValid = Roc.Validation.validateForm(forms.Registration);
        if (isValid) {
            Roc.Core.lockButton(btns.register);
            var requestData = Roc.Validation.getFieldValues(forms.Registration);
            requestData.authenticateUser = registrationOptions.authenticateUser;
            requestData.duringCheckout = registrationOptions.duringCheckout;

            $.ajax({
                url: '/ajax/Register',
                type: 'POST',
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify(requestData),
                beforeSend: registrationOptions.beforeSend || null,
                complete: function (xhr) {
                    var response = xhr.responseJSON || {};
                    if (response.errorMessage) {
                        Roc.UI.template('formErrorSummary-Tmp', { message: response.errorMessage }).then(function (renderedTemplate) {
                            $errorContainer.html(renderedTemplate);
                        });
                    }
                    Roc.Core.releaseLockedButton(btns.register);
                    Roc.EventManager.notify(Roc.Events.users.REGISTER, xhr);
                }
            });

        }
        return isValid;
    }

    function forgotPassword() {
        var $formWrapper = $(forms.ForgotPassword.Fields[0].Field).closest('.formee');
        var $errorContainer = Roc.UI.getErrorSummaryWrapper($formWrapper);
        var isValid = Roc.Validation.validateForm(forms.ForgotPassword);

        $errorContainer.html('');

        if (isValid) {
            Roc.Core.lockButton(btns.forgotPass);
            var requestData = Roc.Validation.getFieldValues(forms.ForgotPassword);
            $.ajax({
                url: '/ajax/SendForgotPasswordEmail',
                type: 'POST',
                data: JSON.stringify(requestData),
                contentType: 'application/json',
                dataType: 'json',
                complete: function (xhr) {                    
                    var response = xhr.responseJSON || {};
                    if (response.success) {
                        $('#forgotForm').hide();
                        $('#checkEmail').show();
                    } 
                   
                    if (response.errorMessage) {
                        Roc.UI.template('formErrorSummary-Tmp', { message: response.errorMessage }).then(function (renderedTemplate) {
                            $errorContainer.html(renderedTemplate);
                        });
                    }
                    Roc.Core.releaseLockedButton(btns.forgotPass);
                    Roc.EventManager.notify(Roc.Events.users.FORGOT_PASSWORD, xhr);
                }
            });
        }
    }

    function changePassword() {
        var $formWrapper = $(forms.ChangePassword.Fields[0].Field).closest('.formee');
        var $errorContainer = Roc.UI.getErrorSummaryWrapper($formWrapper);
        var isValid = Roc.Validation.validateForm(forms.ChangePassword);

        $errorContainer.html('');

        if (isValid) {
            if (changePasswordData.$pass.val() !== changePasswordData.$pass2.val()) {
                Roc.UI.template('formErrorSummary-Tmp', { message: 'Given passwords aren\'t the same' }).then(function (renderedTemplate) {
                    $errorContainer.html(renderedTemplate);
                });
            } else {
                Roc.Core.lockButton(btns.changePass);
                var requestData = Roc.Validation.getFieldValues(forms.ChangePassword);

                $.ajax({
                    url: '/ajax/ResetPassword',
                    type: 'POST',
                    data: JSON.stringify(requestData),
                    contentType: 'application/json',
                    dataType: 'json',
                    complete: function (xhr) {                        
                        var response = xhr.responseJSON || {};
                        if (response.success && response.redir) {
                            window.location.replace(response.redir);
                        } else if (response.errorMessage) {
                            Roc.UI.template('formErrorSummary-Tmp', { message: response.errorMessage }).then(function (renderedTemplate) {
                                $errorContainer.html(renderedTemplate);
                            });
                        } else {
                            Roc.UI.ajaxErrorPopup(xhr);
                        }
                        


                        Roc.Core.releaseLockedButton(btns.changePass);
                        Roc.EventManager.notify(Roc.Events.users.CHANGE_PASSWORD, xhr);
                    }
                });
            }
        }
    }

    function editUserProfile() {
        var $formWrapper = $(forms.EditProfile.Fields[0].Field).closest('.formee');
        var $errorContainer = Roc.UI.getErrorSummaryWrapper($formWrapper);
        var isValid = Roc.Validation.validateForm(forms.EditProfile);

        if (isValid) {
            var requestData = Roc.Validation.getFieldValues(forms.EditProfile);

            $.ajax({
                url: '/ajax/EditUserProfile',
                type: 'POST',
                data: JSON.stringify(requestData),
                contentType: 'application/json',
                dataType: 'json',
                complete: function(xhr) {
                    var response = xhr.responseJSON || {};
                    if (response.errorMessage) {
                        Roc.UI.template('formErrorSummary-Tmp', { message: response.errorMessage })
                            .then(function(renderedTemplate) {
                                $errorContainer.html(renderedTemplate);
                            });
                    }

                    Roc.Core.releaseLockedButton(btns.editProfile);
                    Roc.EventManager.notify(Roc.Events.users.EDIT_ACCOUNT, xhr);
                }
            });
        }
    }

    function editAccount() {
        var $formWrapper = $(forms.EditAccount.Fields[0].Field).closest('.formee');
        var $errorContainer = Roc.UI.getErrorSummaryWrapper($formWrapper);
        var isValid = Roc.Validation.validateForm(forms.EditAccount);

        $errorContainer.html('');

        if (isValid) {
            if (editAccountData.$newPass1.val() !== editAccountData.$newPass2.val()) {
                Roc.UI.template('formErrorSummary-Tmp', { message: '"New Password" and "Confirm New Password" aren\'t the same' }).then(function (renderedTemplate) {
                    $errorContainer.html(renderedTemplate);
                });
            } else {
                Roc.Core.lockButton(btns.editAccount);
                var requestData = Roc.Validation.getFieldValues(forms.EditAccount);

                $.ajax({
                    url: '/ajax/EditAccount',
                    type: 'POST',
                    data: JSON.stringify(requestData),
                    contentType: 'application/json',
                    dataType: 'json',
                    complete: function (xhr) {                        
                        var response = xhr.responseJSON || {};
                        if (response.errorMessage) {
                            Roc.UI.template('formErrorSummary-Tmp', { message: response.errorMessage }).then(function (renderedTemplate) {
                                $errorContainer.html(renderedTemplate);
                            });
                        }

                        Roc.Core.releaseLockedButton(btns.editAccount);
                        Roc.EventManager.notify(Roc.Events.users.EDIT_ACCOUNT, xhr);
                    }
                });
            }
        }
    }

    function isLoggedIn() {
        return Roc.Core.getCookie('access_token') !== null;
    }

    var Users = {
        forms: forms,
        initLogin: initLogin,
        initRegistration: initRegistration,
        initForgotPassword: initForgotPassword,
        initEditAccount: initEditAccount,
        initEditProfile: initEditProfile,
        login: login,
        logout: logout,
        register: register,
        forgotPassword: forgotPassword,
        changePassword: changePassword,
        editAccount: editAccount,
        editAccountOptions: editAccountOptions,
        isLoggedIn: isLoggedIn
    };

    Roc.Logger.debug('Users.js Loaded:', Users);

    return Users;
});
